var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProdejnyMapPathKolin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "170.5px",
    height: "102.479px",
    viewBox: "-48.5 112.813 170.5 102.479",
    enableBackground: "new -48.5 112.813 170.5 102.479",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    d: "M24.667,126.631 c0.919,0.104,1.829,0.215,2.73,0.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeDasharray: "5.6784,5.6784",
    d: " M33.012,127.815c48.555,8.354,69.666,38.277,72.738,41.331c14.674,14.583,13.243,26.472,10.695,32.738"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    d: "M115.205,204.435 c-0.845,1.473-1.548,2.265-1.548,2.265"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M20.368,127.114c0.82-1.047,0.582-2.521-0.53-3.293c-1.11-0.773-2.672-0.551-3.493,0.496 c-0.822,1.047-0.583,2.521,0.527,3.297C17.984,128.385,19.547,128.164,20.368,127.114"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    cx: 111,
    cy: 210.387,
    rx: 2.1,
    ry: 1.981
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdejnyMapPathKolin);
export default __webpack_public_path__ + "static/media/prodejny_map_path_kolin.c88dcbed67488c1ad2c96e083d3b4be9.svg";
export { ForwardRef as ReactComponent };